import React, { useState } from "react";
import { useTranslations } from "use-intl";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

interface ContextInputProps {
  question: string;
  details?: string;
  onSubmit: (contextText: string) => void;
  isSubmitting?: boolean;
}

const ContextInput: React.FC<ContextInputProps> = ({
  question,
  details,
  onSubmit,
  isSubmitting = false,
}) => {
  const t = useTranslations("consultantReview.context");
  const [contextText, setContextText] = useState("");
  const maxLength = 500;

  const handleSubmit = () => {
    if (contextText.trim().length === 0) return;
    onSubmit(contextText);
  };

  return (
    <div className="space-y-4">
      <div className="rounded-lg border border-yellow-200 bg-yellow-50 p-4">
        <h3 className="font-semibold text-lg mb-2">{question}</h3>
        {details && (
          <p className="text-sm text-muted-foreground">{details}</p>
        )}
      </div>

      <div className="space-y-2">
        <Label htmlFor="context-input">{t("response")}</Label>
        <Textarea
          id="context-input"
          placeholder={t("placeholder")}
          value={contextText}
          onChange={(e) => setContextText(e.target.value)}
          maxLength={maxLength}
          className="min-h-[120px]"
        />
        <div className="flex justify-between items-center">
          <p className="text-xs text-muted-foreground">
            {t("characters", { count: String(contextText.length), max: String(maxLength) })}
          </p>
        </div>
      </div>

      <Button
        className="w-full"
        onClick={handleSubmit}
        disabled={contextText.trim().length === 0 || isSubmitting}
      >
        {isSubmitting ? t("submitting") : t("submit")}
      </Button>
    </div>
  );
};

export default ContextInput;
